import logging from '@sstdev/lib_logging';
import { session, network } from 'lib_ui-services';
import getFullURL from 'lib_ui-services/src/http/getFullURL';

const _p = {
    logout: session.logout,
    getTempToken,
    httpGet: rawGet,
    httpPost: rawPost,
    getNetworkStatus: network.getStatus,
    getPasswordChangeTicket
};

export const _private = _p;

export default {
    verb: 'doingCreate',
    namespace: 'security',
    relation: 'profile',
    description: 'Create a Password Change Ticket via Auth0',
    type: 'setPassword',
    logic: doingCreate
};

async function doingCreate({ data, context }) {
    if (!data.record || context.type !== 'setPassword') return;

    const { tokenString, userName } = data.record;

    const networkStatus = await _p.getNetworkStatus();
    if (networkStatus.isOnline) {
        // Get a temporary token from the server
        const tempToken = await _p.getTempToken(tokenString, userName);

        // Get a password change ticket from the server
        // This will be in the form of a link to the Auth0 set password page
        const { ticket } = await _p.getPasswordChangeTicket(tempToken, userName);

        // Logout and redirect the user to the Auth0 set password page
        _p.logout(true, true, ticket);
    } else {
        throw new Error('Unable to set a new password while offline. Please go online and try again.');
    }
}

async function getPasswordChangeTicket(tempToken, userName) {
    const url = getFullURL('/api/security/changePasswordTicket');
    const data = { userName };
    const params = setPostMethod(data, { Authorization: tempToken });
    return _p.httpPost(url, params);
}

async function getTempToken(tokenString, userName) {
    const url = getFullURL(`/api/security/validateToken?token=${tokenString}`);
    const tempToken = await _p.httpGet(url, {
        Accept: 'application/json'
    });
    if (tempToken?.userName?.toLowerCase() !== userName?.toLowerCase()) {
        throw new Error('Invalid User Email');
    }
    if (tempToken?.tokenKey) {
        return tempToken.tokenKey;
    } else {
        logging.error('Unknown User or Invalid/Expired token');
        return null;
    }
}

// We need to bypass the default http.get and http.post functionality since we're using our own
// JWT authentication and are not yet authenticated with Auth0
async function rawGet(url, headers) {
    const params = {
        method: 'GET',
        headers
    };
    const response = await fetch(url, params);
    if (response.ok) {
        return response.json();
    }
}

async function rawPost(url, params) {
    const response = await fetch(url, params);
    if (response.ok) {
        return response.json();
    }
}

function setPostMethod(data, headers = {}) {
    headers = {
        'content-type': 'application/json',
        ...headers
    };
    return {
        method: 'POST',
        body: JSON.stringify(data),
        headers
    };
}
